export default __webpack_public_path__ + "static/media/sticker1.73942f38.png";